export default {
    name: 'appointment_subject',
    definition: {
        active: '',
        color: '',
        description: '',
    },
};
